// extracted by mini-css-extract-plugin
export var pillWrapper = "_pq-0";
export var showOverflow = "_pq-1";